var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"to-top-btn to-top-btn--hidden",attrs:{"id":"to-top"},on:{"click":function($event){if($event.target !== $event.currentTarget)return null;return _vm.scrollToTop.apply(null, arguments)}}},[_c('i',{staticClass:"arrow up"})])
}
var staticRenderFns = []

export { render, staticRenderFns }